const ZOHO_SALESIQ_WIDGET_URL =
  "https://salesiq.zohopublic.com/widget?wc=siqec43aa17920446dfe77ed405e5fd31f325c28d32fd25ca92450b997ac385bdb9548fb6d665de08e71adb1a79f6bb1d3a";

const SCRIPT_ID = "zsiqscript";
const INIT_SCRIPT_ID = "zsiq-init";

let openListener = null;
let closeListener = null;

function ensureSalesIQStub() {
  window.$zoho = window.$zoho || {};
  window.$zoho.salesiq = window.$zoho.salesiq || { ready() {} };
}

function setZohoFloatButtonVisible(show) {
  window.$zoho?.salesiq?.floatbutton?.visible?.(show ? "show" : "hide");
}

function configureWidget() {
  if (!window.$zoho?.salesiq) return;

  window.$zoho.salesiq.chat?.theme?.("#0F172A");
  setZohoFloatButtonVisible(false);

  window.$zoho.salesiq.floatwindow.open(() => {
    setZohoFloatButtonVisible(true);
    document.body.classList.add("explore-chat-open");
    openListener?.();
  });

  window.$zoho.salesiq.floatwindow.close(() => {
    setZohoFloatButtonVisible(false);
    document.body.classList.remove("explore-chat-open");
    closeListener?.();
  });
}

export function registerSalesIQListeners({ onOpen, onClose } = {}) {
  openListener = onOpen || null;
  closeListener = onClose || null;
}

export function openSalesIQChat() {
  const showChat = () => {
    if (window.$zoho?.salesiq?.floatwindow) {
      window.$zoho.salesiq.floatwindow.visible("show");
      setZohoFloatButtonVisible(true);
      document.body.classList.add("explore-chat-open");
      openListener?.();
      return true;
    }
    return false;
  };

  if (showChat()) return;

  ensureSalesIQStub();
  const previousReady = window.$zoho.salesiq.ready;
  window.$zoho.salesiq.ready = function onSalesIQReadyForOpen() {
    if (typeof previousReady === "function") previousReady();
    configureWidget();
    showChat();
  };
}

export function loadSalesIQScript(listeners) {
  registerSalesIQListeners(listeners);
  ensureSalesIQStub();

  const previousReady = window.$zoho.salesiq.ready;
  window.$zoho.salesiq.ready = function onSalesIQReady() {
    if (typeof previousReady === "function") previousReady();
    configureWidget();
  };

  if (!document.getElementById(INIT_SCRIPT_ID)) {
    const initScript = document.createElement("script");
    initScript.id = INIT_SCRIPT_ID;
    initScript.textContent =
      "window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}";
    document.body.appendChild(initScript);
  }

  if (document.getElementById(SCRIPT_ID)) {
    configureWidget();
    return;
  }

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.src = ZOHO_SALESIQ_WIDGET_URL;
  script.defer = true;
  document.body.appendChild(script);
}

export function unloadSalesIQScript() {
  if (window.$zoho?.salesiq?.floatwindow) {
    window.$zoho.salesiq.floatwindow.visible("hide");
  }
  setZohoFloatButtonVisible(false);
  registerSalesIQListeners();
  document.body.classList.remove("explore-chat-open");

  document.getElementById(SCRIPT_ID)?.remove();
  document.getElementById(INIT_SCRIPT_ID)?.remove();
  document.getElementById("zsiqwidget")?.remove();

  document
    .querySelectorAll(".zsiq_floatmain, .zsiq_custommain, .zsiq_float")
    .forEach((node) => node.remove());
}
